// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer {
  padding: 20px 0;
  margin: 0 auto;
}
.footer h2 {
  font-size: 16px;
  line-height: 26px;
  font-weight: 700;
  color: #ffffff;
  text-align: left;
}
.footer .logo img {
  width: auto;
  height: 66px;
}
.footer .social {
  display: flex;
  gap: 20px;
}
.footer .copywrite {
  padding-top: 40px;
}
.footer .copywrite:before {
  content: '';
  display: none;
  background-color: #000000;
  width: 100%;
  height: 1px;
  margin-bottom: 40px;
}
@media (min-width: 768px) {
  .footer .copywrite:before {
    display: block;
  }
}
@media (min-width: 768px) {
  .footer .logo img {
    height: 80px;
  }
}
@media (min-width: 992px) {
  .footer h2 {
    font-size: 32px;
    line-height: 50px;
    font-weight: 700;
    color: #ffffff;
  }
} `, "",{"version":3,"sources":["webpack://./src/components/Footer/footer.scss","webpack://./src/components/Footer/footer.css"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,cAAA;ACCF;ADCE;EACE,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;ACCJ;ADGI;EACE,WAAA;EACA,YAAA;ACDN;ADKE;EACE,aAAA;EACA,SAAA;ACHJ;ADME;EACE,iBAAA;ACJJ;ADMI;EACE,WAAA;EACA,aAAA;EACA,yBAAA;EACA,WAAA;EACA,WAAA;EACA,mBAAA;ACJN;ADMM;EARF;IASI,cAAA;ECHN;AACF;ADOE;EAEI;IACE,YAAA;ECNN;AACF;ADUE;EACE;IACE,eAAA;IACA,iBAAA;IACA,gBAAA;IACA,cAAA;ECRJ;AACF","sourcesContent":[".footer {\n  padding: 20px 0;\n  margin: 0 auto;\n\n  h2 {\n    font-size: 16px;\n    line-height: 26px;\n    font-weight: 700;\n    color: #ffffff;\n    text-align: left;\n  }\n\n  .logo {\n    img {\n      width: auto;\n      height: 66px;\n    }\n  }\n\n  .social {\n    display: flex;\n    gap: 20px;\n  }\n\n  .copywrite {\n    padding-top: 40px;\n\n    &:before {\n      content: '';\n      display: none;\n      background-color: #000000;\n      width: 100%;\n      height: 1px;\n      margin-bottom: 40px;\n\n      @media (min-width: 768px) {\n        display: block;\n      }\n    }\n  }\n\n  @media (min-width: 768px) {\n    .logo {\n      img {\n        height: 80px;\n      }\n    }\n  }\n\n  @media (min-width: 992px) {\n    h2 {\n      font-size: 32px;\n      line-height: 50px;\n      font-weight: 700;\n      color: #ffffff;\n    }\n  }\n}\n",".footer {\n  padding: 20px 0;\n  margin: 0 auto;\n}\n.footer h2 {\n  font-size: 16px;\n  line-height: 26px;\n  font-weight: 700;\n  color: #ffffff;\n  text-align: left;\n}\n.footer .logo img {\n  width: auto;\n  height: 66px;\n}\n.footer .social {\n  display: flex;\n  gap: 20px;\n}\n.footer .copywrite {\n  padding-top: 40px;\n}\n.footer .copywrite:before {\n  content: '';\n  display: none;\n  background-color: #000000;\n  width: 100%;\n  height: 1px;\n  margin-bottom: 40px;\n}\n@media (min-width: 768px) {\n  .footer .copywrite:before {\n    display: block;\n  }\n}\n@media (min-width: 768px) {\n  .footer .logo img {\n    height: 80px;\n  }\n}\n@media (min-width: 992px) {\n  .footer h2 {\n    font-size: 32px;\n    line-height: 50px;\n    font-weight: 700;\n    color: #ffffff;\n  }\n} /*# sourceMappingURL=footer.css.map */\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
